const Builder = require('./BuilderBase');
const DateTime = require('./RangeDateTime');
const RangeNumber = require('./RangeNumber');
const filters = require('./filters');

module.exports = class Range extends Builder {
    constructor(title, properties, type) {
        const elementType = type === 'search' ? 'searchElement_Range' : 'actionElement_Range';
        super(elementType, title, properties);
        this.elementType = elementType;
    }

    fromDateTime(properties) {
        const dateTime = new DateTime('from', properties);
        this.addChildBlock(dateTime, 'from');
        return dateTime;
    }

    toDateTime(properties) {
        const dateTime = new DateTime('to', properties);
        this.addChildBlock(dateTime, 'to');
        return dateTime;
    }
    fromNumber(properties) {
        const number = new RangeNumber('from', properties);
        this.addChildBlock(number, 'from');
        return number;
    }

    toNumber(properties) {
        const number = new RangeNumber('to', properties);
        this.addChildBlock(number, 'to');
        return number;
    }

    filter(properties, filterType) {
        if (this.elementType !== 'searchElement_Range') {
            throw new Error('Filters can only be added to searchElement_Range types');
        }
        const Filter = filters[filterType];
        const filter = new Filter(properties);
        this.addChildBlock(filter, 'filters');
        return filter;
    }
};
